import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";
import Header from "@/components/common/header/DefaultHeader";
import { getWebCMS } from '@/api/PDP';
import "./disclaimer.css"
import Footer from "@/components/common/footer/Footer";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const Disclaimer = () => {
  return (
    <div>
      <Header />
       <section className="hero-image">
        <div className="overlay-content">
          <h1 className="hero-title">Disclaimer And Trademark</h1>
        </div>
      </section>

      <main className="container my-5">
        <h5 className="fw-bold ">DISCLAIMER</h5>
        <p className="disDesc">
          Hubzu does not make any express or implied warranties, endorsements or
          representations whatsoever as to the accuracy of the information,
          content or materials contained on this website. By visiting the site,
          viewing, accessing or otherwise using any of the services or
          information created, collected, compiled or submitted to Hubzu, you
          agree to be bound by the <a href="/about/privacy">Privacy Rights</a> and the{" "} <a href="/about/terms">Terms & Conditions</a> applicable to this site.
        </p>

        <h5 className="fw-bold mt-4">TRADEMARK</h5>
        <p className="tradeDesc">
          Hubzu, the Hubzu logo and all other marks identified herein are
          trademarks or service marks of Altisource S.à r.l. or its
          subsidiaries. These marks may be registered with the United States
          Patent and Trademark Office and Intellectual Property Offices of other
          countries.
        </p>
      </main>


      {/* footer */}
      {/* <section className="discFooter footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>
    </div>
  );
};

export default Disclaimer;
